<template>
    <!-- Filter leads -->
    <CContainer fluid>
        <CRow
            alignHorizontal="end"
        >
            <div class="position-relative">
                <CBadge color="secondary" class="badge--round badge--absolute" v-if="countFiltersActive()">{{ countFiltersActive() }}</CBadge>
                <CDropdown
                    color="secondary"
                    class="mb-3"
                >
                    <template #toggler>
                        <CButton>
                            <CIcon :content="$options.icons.cilListFilter" />
                        </CButton>
                    </template>
                    <CDropdownItem
                        v-for="(item, index) in fields_filter"
                        :key="item.key"
                        @click="selectFilter(index)"
                        :class="[
                            (checkFilterActive(index))? 'shadow':''
                        ]"
                    >
                        <div class="form-check">
                            <input 
                                type="checkbox" 
                                class="form-check-input"
                                :id="item.key"
                                v-model="fields_filter[index]._filter.active"
                                @click="toggleFiledFilterActive"
                            >
                            <label class="form-check-label" :for="item.key">{{ item.label }}</label>
                        </div>
                    </CDropdownItem>

                    
                </CDropdown>
            </div>
            
        </CRow>
        <CRow v-if="filter_index_active != null && fields_filter[filter_index_active]._filter.active">
            <CCol sm="12">
                <CSelect
                    v-if="fields_filter[filter_index_active]._filter.type == 'select'"
                    :options="fields_filter[filter_index_active]._filter.options"
                    :value.sync="fields_filter[filter_index_active]._filter.value"
                    :placeholder="filter_placeholder"
                >
                    <template #prepend>
                        <CDropdown
                            :togglerText="$t(fields_filter[filter_index_active]._filter.condition)"
                        >
                            <CDropdownItem
                            >
                                {{ $t(fields_filter[filter_index_active]._filter.condition) }}
                            </CDropdownItem>
                        </CDropdown>
                    </template>
                    <template #append>
                        <CButton
                            @click="runFilter()"
                        >
                            {{ $t('Ready')}}
                        </CButton>
                    </template>

                </CSelect>
                <CInput
                    v-else
                    class="input-filter"
                    :value.sync="fields_filter[filter_index_active]._filter.value"
                    :placeholder="filter_placeholder"
                >
                    <template #prepend>
                        <CDropdown
                            :togglerText="$t(fields_filter[filter_index_active]._filter.condition)"
                        >
                            <CDropdownItem
                                v-for="(item) in conditions"
                                :key="item.key"
                                @click="fields_filter[filter_index_active]._filter.condition = item"
                            >
                                {{ $t(item) }}
                            </CDropdownItem>
                        </CDropdown>
                    </template>
                    <template #append>
                        <CButton
                            @click="runFilter()"
                        >
                            {{ $t('Ready')}}
                        </CButton>
                    </template>
                </CInput>
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>

import Calendar from 'v-calendar/lib/components/calendar.umd';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import { cilFilter,cilListFilter } from '@coreui/icons';
import { validationMixin } from "vuelidate"
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
export default {
    name: "FilterAdvanceComponent",
    icons:{
        cilFilter,
        cilListFilter
    },
    components:{
        Calendar,
        DatePicker
    },
    mixins: [validationMixin],
    data(){
        return {
            json_filter: {}, 
            fields_filter:[],
            /* filter_selected:{
                key:null,
                value:null,
                label:null,
                active:false,
                condition:'contains'
            }, */
            filter_index_active: null,
            conditions:[
                'contains',
                'not_contains',
                'is_equal_to',
                'is_not_equal_to',
                'is_in_list',
                'not_in_list',
                /*'start_by',
                'not_start_by' */
            ]
        }
    },
    computed:{
        filter_placeholder:function(){
            let placeholder = this.$t('select_a_field');
            let label;
            if(this.filter_index_active)
                this.fields_filter[this.filter_index_active].label;
                label = this.fields_filter[this.filter_index_active].label;
            if(label){
                placeholder = this.$t('filter_the') + ' ' + label;
            }
            return placeholder;
        },
        ...mapGetters({
            store_filter_advance:"filter/filter_advance"
        }),  
    },
    props:{
        value:{
            default:undefined
        },
        fields:{
            default:undefined
        },
        filters:{
            default:undefined
        }
    },

    validations: {
        
    },
    watch:{
        json_filter(newValue){
            this.$emit('update:filters',newValue);
            this.saveStoreFilterAdvance(newValue);
        },
        filter_index_active(newValue){
            this.$emit("update:checkbox", newValue);
        }
    },
    methods:{
        checkFieldValid(fieldName){
            const field = this.$v[fieldName];
            if (!field.$dirty) {
                return null
            } 
            return !(field.$invalid || field.$model === '')
        },
        checkFilterActive(index){

            let active = false;
            if(index != null)
                active = this.fields_filter[index]._filter.active;
            return active;
        },
        saveStoreFilterAdvance(filters){
            this.$store.dispatch('filter/saveFilterAdvance', {
                filter_advance:filters
            });
        },
        selectFilter(index){
            this.filter_index_active = index;

            this.fields_filter[index]._filter.active = true; //!this.fields_filter[index]._filter.active;
            
            /* this.filter_selected.active = !this.filter_selected.active; */

            /* if(this.filter_selected.key != this.fields_filter[index].key){
                this.filter_selected.active = true;
            } */

            /* if(this.filter_selected.active){
                this.filter_selected.key = this.fields_filter[index].key;
                this.filter_selected.label = this.fields_filter[index].label;
                this.filter_selected.value = this.fields_filter[index]._filter.value;
                this.filter_selected.condition = this.fields_filter[index]._filter.condition;
                this.fields_filter[index]._filter.active = true;
            }else{
                this.resetFilter();
            } */

            /* this.resetFilter(); */
            this.filter();
        },

        toggleFiledFilterActive(event){
            //event.preventDefault();
            event.stopPropagation();
            /* event.target.checked = true; */
            let option = event.target.id;
            let index = this.fields_filter.findIndex((item)=>{
                return option == item.key; 
            });
            this.fields_filter[index]._filter.active = !this.fields_filter[index]._filter.active;
            this.filter();
        },
        countFiltersActive(){
            let filters_active = this.fields_filter.filter((item)=>{
                return item._filter.active;
            });
            return filters_active.length;
        },
        formatFieldsFilter(fields){
            return fields.filter((item)=>{
                return item._filter != false;
            }).map((item)=>{
                let format_item = item;
                if(typeof format_item._filter != 'object')
                    format_item._filter = {
                        active:false,
                        value:null,
                        placeholder:"filter",
                        condition:this.conditions[0],
                        type:'text'
                    }
                return format_item;
            })
        },
        formartJsonFilter(fields){
            let temp_json_filter = {};
            let filters_active = fields.filter((item)=>{
                return item._filter.active;
            });
            for (let i = 0; i < filters_active.length; i++) {
                const filter = filters_active[i];
                temp_json_filter= {
                    ...temp_json_filter,
                    [filter.key]:{
                        value:filter._filter.value,
                        condition:filter._filter.condition
                    }
                }
            }

            this.json_filter = temp_json_filter;
        },
        resetFilter(){
            /* this.filter_selected.key = null;
            this.filter_selected.label = null;
            this.filter_selected.value = null;
            this.filter_selected.condition = this.conditions[0];
            this.filter_selected.active = false; */
            this.filter_index_active = null;
        },
        filter(){

            /* if(this.filter_index_active != null){

                let index = this.fields_filter.findIndex((item)=>{
                    return item.key == this.filter_selected.key; 
                });
                this.fields_filter[index]._filter.value = this.filter_selected.value;
                this.fields_filter[index]._filter.condition = this.filter_selected.condition;
                 
            } */

            this.formartJsonFilter(this.fields_filter);
            
        },

        runFilter(){
            this.filter();
            

            this.saveStoreFilterAdvance(this.json_filter);
            this.$emit('filterData', {
                json_filter:this.json_filter
            });
            this.resetFilter();
        }
    },
    created(){
        this.fields_filter = this.formatFieldsFilter(this.fields);
        this.json_filter = (this.filters) ? this.filters:{};
    }
    
}
</script>

<style lang="scss" scoped>
    input{
        height: auto !important;
    }
    .input-filter{
            & input{
                position: relative;
                & ::placeholder{
                color:blue;
                position: absolute;
                top: 0;
            }
        }
    }

</style>